import React, { useState } from 'react';
import { Calendar } from 'lucide-react';
export interface DateRangePickerProps {
  startDate?: string;
  endDate?: string;
  onChange?: (startDate: string, endDate: string) => void;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  error?: string;
  'data-id'?: string;
}
function DateRangePicker({
  startDate = '',
  endDate = '',
  onChange,
  label,
  placeholder = 'Select date range',
  disabled = false,
  error,
  'data-id': dataId
}: DateRangePickerProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [tempStart, setTempStart] = useState(startDate);
  const [tempEnd, setTempEnd] = useState(endDate);
  const formatRange = (start: string, end: string) => {
    if (!start || !end) return placeholder;
    const s = new Date(start).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
    const e = new Date(end).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
    return `${s} - ${e}`;
  };
  const handleApply = () => {
    if (tempStart && tempEnd && onChange) {
      onChange(tempStart, tempEnd);
    }
    setIsOpen(false);
  };
  const handleCancel = () => {
    setTempStart(startDate);
    setTempEnd(endDate);
    setIsOpen(false);
  };
  return <div className="relative" data-id="element-2264" data-mp="36g4lekh5ah3b">
      {label && <label className="block text-sm font-medium text-[#475569] mb-1" data-id="element-2265" data-mp="36d09t21coj2m">
          {label}
        </label>}

      <button type="button" onClick={() => !disabled && setIsOpen(!isOpen)} disabled={disabled} className={`w-full h-12 px-4 flex items-center justify-between gap-2 bg-white border rounded-md text-base transition-all ${error ? 'border-[#EF4444]' : 'border-[#CBD5E1] hover:border-[#0EA5E9]'} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`} data-id="element-2266" data-mp="3u2ulvhdui3lt">
        <span className={startDate && endDate ? 'text-[#0F172A]' : 'text-[#94A3B8]'} data-id="element-2267" data-mp="29okfksnaplj6">
          {formatRange(startDate, endDate)}
        </span>
        <Calendar className="w-5 h-5" data-id="element-2268" data-mp="2dob5yv8wtzn6" />
      </button>

      {error && <p className="mt-1 text-sm text-[#EF4444]" data-id="element-2269" data-mp="k6djucf1evqb">{error}</p>}

      {isOpen && <>
          <div className="fixed inset-0 z-10" onClick={handleCancel} data-id="element-2270" data-mp="f8c4a1gtlejl" />
          <div className="absolute left-0 right-0 mt-2 bg-white border border-[#CBD5E1] rounded-lg shadow-lg z-20 p-4" data-id="element-2271" data-mp="ahlwkhkx8zlq">
            <h3 className="text-base font-semibold text-[#0F172A] mb-4" data-id="element-2272" data-mp="5jkf213598cd">
              Select Date Range
            </h3>
            <div className="space-y-3" data-id="element-2273" data-mp="1hysfo0t5foz">
              <div data-id="element-2274" data-mp="1eukcfk81zt1">
                <label className="block text-sm font-medium text-[#475569] mb-1" data-id="element-2275" data-mp="3snry0pqzc69g">
                  Start Date
                </label>
                <input type="date" value={tempStart} onChange={e => setTempStart(e.target.value)} max={tempEnd || undefined} className="w-full h-12 px-3 border border-[#CBD5E1] rounded-md" data-id="element-2276" data-mp="3np6vuks63cid" />
              </div>
              <div data-id="element-2277" data-mp="1lwipi2k888yd">
                <label className="block text-sm font-medium text-[#475569] mb-1" data-id="element-2278" data-mp="1luy1kvsf3o9h">
                  End Date
                </label>
                <input type="date" value={tempEnd} onChange={e => setTempEnd(e.target.value)} min={tempStart || undefined} className="w-full h-12 px-3 border border-[#CBD5E1] rounded-md" data-id="element-2279" data-mp="1pfhrcepal96g" />
              </div>
              <div className="flex gap-2 pt-2" data-id="element-2280" data-mp="1y706cmai5ixy">
                <button type="button" onClick={handleCancel} className="flex-1 h-10 px-4 text-[#475569] bg-white border border-[#CBD5E1] rounded-md" data-id="element-2281" data-mp="1y9cyttdvzbp9">
                  Cancel
                </button>
                <button type="button" onClick={handleApply} disabled={!tempStart || !tempEnd} className="flex-1 h-10 px-4 text-white bg-[#0EA5E9] rounded-md disabled:opacity-50" data-id="element-2282" data-mp="16i6uf0r4uru6">
                  Apply
                </button>
              </div>
            </div>
          </div>
        </>}
    </div>;
}
export { DateRangePicker };
export default DateRangePicker;